<!-- 需要根据登录状态展示内容时使用 -->
<script lang="ts">
  import BasicView from './BasicView.svelte';
  import {browser$} from '@/streams/browser';
  import {userStatus$} from '@/streams/auth';

  interface $$Slots {
    init?: {};
    login?: {};
    logout?: {};
    // = login + logout
    default?: {};
  }

  export let height: string;
  export let mheight = '';
  export let background: string = '';

  $: hasDefault = !!(<$$Slots>$$slots.default);
</script>

<BasicView {...$$props} loaded={$userStatus$ !== 'Init' && $browser$}>
  <slot name="init" slot="skeleton" />

  {#if hasDefault}
    <slot />
  {:else if $userStatus$ === 'Login'}
    <slot name="login" />
  {:else if $userStatus$ === 'Logout'}
    <slot name="logout" />
  {/if}
</BasicView>
